/* Kindly Productpage v2 — koopblok.
 * Twee keuzes: aantal kinderen (Kids-optie) en bezorgfrequentie (Dagen-optie).
 * Samen wijzen ze een variant aan; dit script zet die variant en het aantal
 * stuks (kinderen x aantal 30-daagse periodes) in het formulier en toont de
 * bijbehorende, hardgecodeerde prijzen.
 */
(function () {
  'use strict';

  function init(root) {
    if (root.__kv2Init) return;
    root.__kv2Init = true;

    var dataEl = root.querySelector('[data-kv2-prices]');
    if (!dataEl) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var form = root.querySelector('[data-kv2-form]');
    if (!form) return;

    var idInput = form.querySelector('[data-kv2-id]');
    var qtyInput = form.querySelector('[data-kv2-qty]');
    var submitBtn = form.querySelector('[data-kv2-submit]');
    var ctaLabel = form.querySelector('[data-kv2-cta-label]');
    var ctaPrice = form.querySelector('[data-kv2-cta-price]');
    var ctaWas = form.querySelector('[data-kv2-cta-was]');
    var atcNote = form.querySelector('[data-kv2-atc-note]');
    var onceToggle = form.querySelector('[data-kv2-toggle-once]');

    function selectedKids() {
      var el = form.querySelector('[data-kv2-kids]:checked');
      return el ? el.value : null;
    }

    function selectedFreq() {
      var el = form.querySelector('[data-kv2-freq]:checked');
      return el ? el.value : null;
    }

    // Eenmalig kopen is een schakelaar: dezelfde voorraadduur, zonder herhaling.
    var onceMode = false;
    var onceProp = form.querySelector('[data-kv2-once-prop]');

    function sync() {
      var kids = selectedKids();
      var row = kids ? data.matrix[kids] : null;
      if (!row) return;

      // Prijzen per frequentiekaart.
      // Per kaart drie regels: pouchprijs groot, dan het totaal voor deze
      // levering (alleen als dat afwijkt), dan wat dat per dag is.
      root.querySelectorAll('[data-kv2-pouch]').forEach(function (el) {
        var info = row[el.getAttribute('data-kv2-pouch')];
        el.textContent = info ? info.pouch : '';
      });
      root.querySelectorAll('[data-kv2-total]').forEach(function (el) {
        var info = row[el.getAttribute('data-kv2-total')];
        var toon = !!info && info.showTotal;
        el.textContent = toon
          ? (data.totalLabel || '{price}').replace('{price}', info.total).replace('{days}', info.days)
          : '';
        el.hidden = !toon;
      });
      root.querySelectorAll('[data-kv2-perday]').forEach(function (el) {
        var info = row[el.getAttribute('data-kv2-perday')];
        el.textContent = info
          ? (data.perDayLabel || '{price}/dag').replace('{price}', info.perDay)
          : '';
      });
      // Welkomstkorting in de kaart (alleen zichtbaar bij de gekozen kaart).
      root.querySelectorAll('[data-kv2-welcome]').forEach(function (el) {
        var info = row[el.getAttribute('data-kv2-welcome')];
        el.textContent = info && info.hasWelcome ? '\u2212' + info.welcome : '';
      });
      root.querySelectorAll('[data-kv2-save]').forEach(function (el) {
        var info = row[el.getAttribute('data-kv2-save')];
        if (info && info.save > 0) {
          el.textContent = 'Bespaar ' + info.save + '%';
          el.hidden = false;
        } else {
          el.hidden = true;
        }
      });
      root.querySelectorAll('[data-kv2-warn]').forEach(function (el) {
        var info = row[el.getAttribute('data-kv2-warn')];
        var missing = info && !info.variantId;
        el.textContent = missing ? data.unavailableNote : '';
        el.hidden = !missing;
      });

      // Gekozen combinatie -> variant, aantal, knop.
      var key = selectedFreq();
      var pick = key ? row[key] : null;
      var buyable = !!(pick && pick.variantId);

      if (pick) {
        if (idInput && pick.variantId) idInput.value = pick.variantId;
        if (qtyInput) qtyInput.value = pick.qty;
      }
      if (onceProp) {
        onceProp.disabled = !onceMode;
        onceProp.value = onceMode ? 'Eenmalig' : '';
      }

      if (ctaLabel) ctaLabel.textContent = data.ctaLabel;
      // Op de knop staat wat je nu betaalt; met welkomstkorting is dat de
      // startprijs, met de normale prijs doorgestreept ernaast.
      var nu = null, was = null;
      if (pick && buyable) {
        if (onceMode) {
          nu = pick.refTotal;
        } else if (pick.hasWelcome) {
          nu = pick.firstTotal;
          was = pick.total;
        } else {
          nu = pick.total;
          was = pick.wasTotal;
        }
      }
      if (ctaPrice) ctaPrice.textContent = nu ? ' |  ' + nu : '';
      if (ctaWas) {
        ctaWas.textContent = was || '';
        ctaWas.hidden = !was;
      }
      if (submitBtn) submitBtn.disabled = !buyable;
      if (atcNote) {
        atcNote.textContent = buyable ? '' : data.unavailableNote;
        atcNote.hidden = buyable;
      }

      // Link onder de knop: het bedrag hoort bij dezelfde voorraadduur, dus bij
      // 60 of 90 dagen staat er de eenmalige prijs voor díe periode.
      var after = root.querySelector('[data-kv2-after]');
      var sep = root.querySelector('[data-kv2-sep]');
      if (after) {
        var toon = !!pick && !onceMode && !!data.afterText;
        after.textContent = toon
          ? data.afterText.replace('{price}', pick.total).replace('{days}', pick.days)
          : '';
        after.hidden = !toon;
        if (sep) sep.hidden = !toon;
      }
      if (onceToggle) {
        if (!pick) {
          onceToggle.hidden = true;
        } else {
          onceToggle.hidden = false;
          onceToggle.textContent = onceMode
            ? data.backLink
            : (data.onceLink || '').replace('{price}', pick.refTotal);
        }
      }
    }

    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-kv2-kids], [data-kv2-freq]')) sync();
    });

    // Eenmalig kopen legt het product meteen in de winkelwagen; daarna staat de
    // pagina weer op het abonnement, zodat de knop niet blijft hangen.
    if (onceToggle) {
      onceToggle.addEventListener('click', function () {
        onceMode = true;
        sync();
        if (form.requestSubmit) {
          form.requestSubmit();
        } else {
          form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
        window.setTimeout(function () { onceMode = false; sync(); }, 400);
      });
    }

    // Galerij — schuifbaar spoor met pijltjes, stipjes en thumbnails.
    var track = root.querySelector('[data-kv2-track]');
    if (track) {
      var slides = root.querySelectorAll('[data-kv2-slide]');
      var thumbs = root.querySelectorAll('[data-kv2-thumb]');
      var dots = root.querySelectorAll('[data-kv2-dot]');
      var prev = root.querySelector('[data-kv2-prev]');
      var next = root.querySelector('[data-kv2-next]');
      var current = 0;

      function goTo(index) {
        if (index < 0) index = 0;
        if (index > slides.length - 1) index = slides.length - 1;
        track.scrollTo({ left: track.clientWidth * index, behavior: 'smooth' });
      }

      function mark(index) {
        current = index;
        thumbs.forEach(function (t) {
          t.setAttribute('aria-current', t.getAttribute('data-kv2-thumb') === String(index) ? 'true' : 'false');
        });
        dots.forEach(function (d) {
          d.setAttribute('aria-current', d.getAttribute('data-kv2-dot') === String(index) ? 'true' : 'false');
        });
        if (prev) prev.disabled = index <= 0;
        if (next) next.disabled = index >= slides.length - 1;
      }

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-kv2-thumb'), 10)); });
      });
      dots.forEach(function (d) {
        d.addEventListener('click', function () { goTo(parseInt(d.getAttribute('data-kv2-dot'), 10)); });
      });
      if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
      if (next) next.addEventListener('click', function () { goTo(current + 1); });

      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
      });

      // Bij swipen of scrollen bepaalt de scrollpositie welke foto actief is.
      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var width = track.clientWidth || 1;
          var index = Math.round(track.scrollLeft / width);
          if (index !== current) mark(index);
        });
      }, { passive: true });

      mark(0);
    }

    sync();
  }

  function boot() {
    document.querySelectorAll('[data-kv2-pdp]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
